document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-quick-add]');
  if (!button || button.disabled) return;

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = '…';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
    });
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    const badge = document.querySelector('.site-header__cart-count');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    }
    button.textContent = '✓ Added';
  } catch (error) {
    button.textContent = originalText;
  } finally {
    setTimeout(() => {
      button.disabled = false;
      button.textContent = originalText;
    }, 1500);
  }
});
